import { Button } from "@/components/ui";

type TabFilterProps = {
  tabs: string[];
  selectedTab: string;
  onSelect: (tab: string) => void;
  className?: string;
};

/**
 * Generic tab filter component that can be used across different features
 * Used for filtering data by different statuses or categories
 */
const TabFilter: React.FC<TabFilterProps> = ({
  tabs,
  selectedTab,
  onSelect,
  className = "",
}) => {
  return (
    <div
      className={`w-full px-8 lg:px-0 flex gap-2 justify-center my-4 ${className}`}
    >
      {tabs.map((tab) => (
        <Button
          key={tab}
          onClick={() => onSelect(tab)}
          className={`capitalize ${
            selectedTab === tab
              ? "bg-blue-500 text-white"
              : "bg-white text-blue-500"
          }`}
        >
          {tab}
        </Button>
      ))}
    </div>
  );
};

export default TabFilter;
